import useTranslation from "@/hooks/useTranslation";
import { totalSanitize } from "@/utils/sanitize.util";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

interface IProps {
  open: boolean;
  content: string;
  handleClose: () => void;
  handleDelete: () => void;
}

const DeleteCommentDialog: React.FC<IProps> = ({
  open,
  content,
  handleClose,
  handleDelete,
}) => {
  const { t } = useTranslation("common");
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t("comment.delete.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("comment.delete.sure", { comment: totalSanitize(content) })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t("cancel")}</Button>
        <Button
          onClick={() => {
            handleDelete();
            handleClose();
          }}
          color="primary"
          autoFocus
        >
          {t("submit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCommentDialog;
